module.exports = __webpack_public_path__ + "static/map-35315dd8d8eaed17288b1a16ba65abc0.png";